import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* LIST — the messages of the clients and the masters in one feed, the numbers of the inbox */
export const list = data => {
    const uri = `${env.startpoint}/admin/support/list`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* GET — one message with its author, its subject and the other messages of the author */
export const get = data => {
    const uri = `${env.startpoint}/admin/support/get`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* STATUS — new, in work or resolved, with the note of the administrator */
export const status = data => {
    const uri = `${env.startpoint}/admin/support/status`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
